import React, { Component } from 'react';
import { Button, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
// import '../../css/common.scss';
import '../../css/chooseplan/chooseplan.scss';
import SelectPricePlanModal from './selectPricePlanModal';
import FreeTrialModal from './FreeTrialModal';
import ContactUsModal from './ContactUsModal';

class ChoosePlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlanModalOpen: false,
      isFreeTrialModal: false,
      isContactUsModal: false,
    };
  }

  toggleSelectPlanModal = () => {
    const { isPlanModalOpen } = this.state;
    this.setState({
      isPlanModalOpen: !isPlanModalOpen,
    });
  };

  toggleFreeTrialModal = () => {
    const { isFreeTrialModal } = this.state;
    this.setState({
      isFreeTrialModal: !isFreeTrialModal,
    });
  };

  toggleContactUsModal = () => {
    const { isContactUsModal } = this.state;
    this.setState({
      isContactUsModal: !isContactUsModal,
    });
  };

  render() {
    const { isPlanModalOpen, isFreeTrialModal, isContactUsModal } = this.state;
    return (
      <React.Fragment>
        <main>
          <header>
            <h1>Choose a plan.</h1>
            <h2>Try a free plan for 07 days, No credit required.</h2>
            <Button className="button">Try 7 day free trial</Button>
          </header>
          <section>
            <Grid container>
              <Grid item lg={2} md={2} sm={2} xs={12}>
                <aside>
                  <header>Select User</header>
                  <nav>
                    <ul>
                      <li>Insurance</li>
                      <li>Re-Insurance</li>
                      <li>Banking</li>
                      <li>Seed Company</li>
                      <li>Fertilizer & Agrochemicals</li>
                      <li>Farm Equipments</li>
                      <li>Procurement</li>
                    </ul>
                  </nav>
                </aside>
              </Grid>
              <Grid item lg={10} md={10} sm={10} xs={12}>
                <article className="article">
                  <div className="article__card">
                    <div className="article__card__upper">
                      <h1>Stratgic Reports</h1>
                      <h2>(one time)</h2>
                      <h3>Features</h3>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                    </div>
                    <hr />
                    <div className="article__card__lower">
                      <h1>Pricing</h1>
                      <h2>Based on no of district subscribed</h2>
                      <table>
                        <tbody>
                          <tr>
                            <td>0-10</td>
                            <td>
                              <Button onClick={this.toggleSelectPlanModal}>
                                select
                              </Button>
                            </td>
                          </tr>
                          <tr>
                            <td>11-20</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>21-50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 100</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="article__card__footer">
                      <Button onClick={this.toggleFreeTrialModal}>
                        Free Trial
                      </Button>
                    </div>
                  </div>
                  <div className="article__card">
                    <div className="article__card__upper">
                      <h1>Monitoring API</h1>
                      <h2>(one time)</h2>
                      <h3>Features</h3>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                    </div>
                    <hr />
                    <div className="article__card__lower">
                      <h1>Pricing</h1>
                      <h2>Based on account level</h2>
                      <table>
                        <tbody>
                          <tr>
                            <td>0-10</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>11-20</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>21-50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 100</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="article__card__footer">
                      <Button>Free Trial</Button>
                    </div>
                  </div>
                  <div className="article__card">
                    <div className="article__card__upper">
                      <h1>Lead Generation</h1>
                      <h2>(one time)</h2>
                      <h3>Features</h3>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                    </div>
                    <hr />
                    <div className="article__card__lower">
                      <h1>Pricing</h1>
                      <h2>Based on per lead</h2>
                      <table>
                        <tbody>
                          <tr>
                            <td>0-10</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>11-20</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>21-50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 100</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="article__card__footer">
                      <Button>Free Trial</Button>
                    </div>
                  </div>
                  <div className="article__card">
                    <div className="article__card__upper">
                      <h1>Farm Tagging</h1>
                      <h2>(one time)</h2>
                      <h3>Features</h3>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                      <p>
                        <i className="material-icons">check_circle</i>
                        Lorem ipsum dolar sit amet
                      </p>
                    </div>
                    <hr />
                    <div className="article__card__lower">
                      <h1>Pricing</h1>
                      <h2>Based on account level</h2>
                      <table>
                        <tbody>
                          <tr>
                            <td>0-10</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>11-20</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>21-50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 50</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                          <tr>
                            <td>More than 100</td>
                            <td>
                              <Button>select</Button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="article__card__footer">
                      <Button>Free Trial</Button>
                    </div>
                  </div>
                </article>
              </Grid>
            </Grid>
          </section>
          <footer>
            <Grid container>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <h1>
                  If you want to customize plan just for your organization?
                  {' '}
                </h1>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <Button className="button" onClick={this.toggleContactUsModal}>
                  Contact us
                </Button>
              </Grid>
            </Grid>
          </footer>
        </main>
        <SelectPricePlanModal
          showModal={isPlanModalOpen}
          onClose={this.toggleSelectPlanModal}
        />
        <FreeTrialModal
          showModal={isFreeTrialModal}
          onClose={this.toggleFreeTrialModal}
        />
        <ContactUsModal
          showModal={isContactUsModal}
          onClose={this.toggleContactUsModal}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    null,
    null,
  )(withCookies(ChoosePlan)),
);
